import { BookOpen, LifeBuoy, Keyboard, Mail } from "lucide-react";
import { PageHeader } from "../../shared/ui/PageHeader";
import { Card, CardContent } from "@/components/ui/card";

type HelpLink = {
  icon: typeof BookOpen;
  title: string;
  description: string;
  href: string;
  external?: boolean;
};

const LINKS: HelpLink[] = [
  {
    icon: BookOpen,
    title: "Hướng dẫn sử dụng",
    description: "Tài liệu vận hành Addy HIS: tiếp đón, khám, kê đơn, hoá đơn, báo cáo.",
    href: "https://redmine.idsolutions.com.vn/projects/addy-his/wiki",
    external: true,
  },
  {
    icon: Keyboard,
    title: "Phím tắt",
    description: "Nhấn phím ? ở bất kỳ đâu để mở bảng phím tắt toàn ứng dụng.",
    href: "#shortcuts",
  },
  {
    icon: LifeBuoy,
    title: "Hỗ trợ kỹ thuật",
    description: "Gặp lỗi hoặc cần trợ giúp? Gửi yêu cầu tới đội hỗ trợ ID Solutions.",
    href: "https://redmine.idsolutions.com.vn/projects/addy-his/issues/new",
    external: true,
  },
  {
    icon: Mail,
    title: "Liên hệ",
    description: "Email: support@idsolutions.com.vn — phản hồi trong giờ hành chính.",
    href: "mailto:support@idsolutions.com.vn",
  },
];

/** Help hub — entry point pinned below the settings nav in the sidebar. */
export function HelpPage() {
  return (
    <div>
      <PageHeader
        title="Trợ giúp"
        description="Tài liệu, phím tắt và kênh hỗ trợ cho Addy HIS."
      />
      <div className="grid gap-4 sm:grid-cols-2">
        {LINKS.map((l) => (
          <a
            key={l.title}
            href={l.href}
            target={l.external ? "_blank" : undefined}
            rel={l.external ? "noopener noreferrer" : undefined}
          >
            <Card className="h-full transition-colors hover:border-primary/40 hover:bg-muted/40">
              <CardContent className="flex items-start gap-3 p-5">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary">
                  <l.icon size={20} />
                </span>
                <div className="min-w-0">
                  <h3 className="font-semibold text-foreground">{l.title}</h3>
                  <p className="mt-0.5 text-sm text-muted-foreground">{l.description}</p>
                </div>
              </CardContent>
            </Card>
          </a>
        ))}
      </div>
    </div>
  );
}
